<template>
  <form class="contractor">

    <view-mode v-if="mode === 'view'" @modify="mode = 'edit'"></view-mode>
    <edit-mode v-if="mode === 'edit'" @close="mode = 'view'"></edit-mode>
    <users-list v-if="mode === 'view'"></users-list>
  </form>
</template>

<script>
  import ViewMode from './ContractorViewMode'
  import EditMode from './ContractorEditMode'
  import UsersList from './ContractorUsersList'

  export default {
    components: { ViewMode, EditMode, UsersList },

    data: () => ({
      mode: 'view'
    })
  }
</script>

<style scoped>

</style>
